import { alpha, makeStyles } from '@material-ui/core/styles'

export default makeStyles((theme) => {
  const recordingColor = theme.palette.error.light

  return {
    container: {
      display: 'flex',
      alignItems: 'center',

      color: theme.palette.text.secondary,

      padding: theme.spacing(0.5),
      paddingLeft: theme.spacing(),

      borderWidth: 1,
      borderStyle: 'solid',
      borderColor: recordingColor,
      borderRadius: theme.shape.borderRadius,

      userSelect: 'none',
    },
    icon: {
      background: recordingColor,
      borderRadius: '100%',
      width: 10,
      height: 10,
      marginRight: theme.spacing(),
      boxShadow: `0 0 0 0 ${recordingColor}`,
      animation: '$pulse 2s infinite',
    },
    '@keyframes pulse': {
      '0%': {
        transform: 'scale(0.95)',
        boxShadow: `0 0 0 0 ${alpha(recordingColor, 0.7)}`,
      },
      '70%': {
        transform: 'scale(1)',
        boxShadow: `0 0 0 8px ${alpha(recordingColor, 0)}`,
      },
      '100%': {
        transform: 'scale(0.95)',
        boxShadow: `0 0 0 0 ${alpha(recordingColor, 0)}`,
      },
    },
  }
})
